/**
 * @fileoverview GET handler for the "/engagement/content_blocks/select" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementContentBlocksSelect } from "./constants";
import type { EngagementContentBlocksSelectResult } from "./types";
import { isEngagementContentBlocksSelectResult } from "./validators";

export const getEngagementContentBlocksSelect = reactQueryFetcherAdapter(
  engagementContentBlocksSelect,
  (signal: AbortSignal, query: string, limit: number): Promise<EngagementContentBlocksSelectResult> => {
    return fetch("/engagement/content_blocks/select", "GET", { query, limit }, { signal });
  },
  isEngagementContentBlocksSelectResult
);
